import React from 'react';
import { View } from 'react-native';
import { styles } from './Divider.styles';
import Typography from '../Text/Text';

interface DividerProps {
  text?: string; // Optional text in the middle
  style?: object;
}

const Divider: React.FC<DividerProps> = ({ text, style }) => {
  return (
    <View style={{ ...styles.container, ...style }}>
      <View style={styles.line} />
      {text ? (
        <Typography variant="body2" style={styles.text}>
          {text}
        </Typography>
      ) : null}
      <View style={styles.line} />
    </View>
  );
};

export default Divider;
